<div class="sectionbar">
  <app-opfoelgning-nav></app-opfoelgning-nav>
</div>
<div class="topbar">
  <h1>Opfølgninger på serviceaftaler</h1>
  <div class="topbar__actions">
    @if (opfoelgninger.length > 0) {
      <small>
        Viser {{ opfoelgninger.length }}
        <span>af {{ rowCount }}</span>
        opfoelgninger
      </small>
    }
    @if (canSeeAllUsersOpfoelgninger) {
      <mat-slide-toggle
        class="margin--left-l"
        [(ngModel)]="showForAllUsers"
        color="primary"
        (change)="onShowForAllUsersToggle()"
        >
        Vis for alle brugere
      </mat-slide-toggle>
    }
  </div>
</div>
<div class="page__content subscriptions subscriptions--list">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
    [matSortDisabled]="isLoading"
    [matSortActive]="orderBy"
    [matSortDirection]="orderDir"
    class="mat-elevation-z0 has-notifications table-show-overflow"
    >
    <ng-container matColumnDef="opfoelgning">
      <th mat-header-cell *matHeaderCellDef class="hidden-cell"></th>
      <td mat-cell *matCellDef="let opfoelgning" class="hidden-cell hidden-cell--pinned">
        <button type="button" class="btn-icon opacity-hover" (click)="opfoelgningClick($event, opfoelgning)" [disabled]="!canWrite">
          <app-opfoelgning-button [opfoelgningList]="opfoelgning.serviceaftale.opfoelgningList"></app-opfoelgning-button>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceaftale.serviceAbonnement.produkt.id">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <mat-icon
          [svgIcon]="getProductIcon(opfoelgning.serviceaftale)"
          [matTooltip]="getProductIcon(opfoelgning.serviceaftale) | titlecase"
        ></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="ServiceaftaleState">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <mat-icon
          [matTooltip]="opfoelgning.serviceaftale.serviceaftaleState.text"
          [svgIcon]="getStatusIcon(opfoelgning.serviceaftale)"
        ></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeNavn">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let opfoelgning">
        {{ opfoelgning.serviceaftale.kunde ? opfoelgning.serviceaftale.kunde.anlaegsadresse?.name : '' }}
        @if (opfoelgning.serviceaftale.kunde?.lokation) {
          <span>({{ opfoelgning.serviceaftale.kunde?.lokation }} )</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceaftale.okKundeAftaleNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr</th>
      <td mat-cell *matCellDef="let opfoelgning">{{ opfoelgning.serviceaftale.okKundeAftaleNr }}</td>
    </ng-container>
    <ng-container matColumnDef="adresse">
      <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
      <td mat-cell *matCellDef="let opfoelgning">
        {{ opfoelgning.serviceaftale.kunde ? opfoelgning.serviceaftale.kunde.anlaegsadresse?.adressLine : '' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="telefon">
      <th mat-header-cell *matHeaderCellDef>Telefonnr.</th>
      <td mat-cell *matCellDef="let opfoelgning">
        {{ opfoelgning.serviceaftale.kunde ? ($safeNavigationMigration(opfoelgning.serviceaftale.kunde.anlaegsadresse?.phone) | dkPhoneNumber) : '' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="modifiedOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Senest ændret</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <app-date-user [date]="opfoelgning.modifiedOn" [user]="opfoelgning.modifiedBy"></app-date-user>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oprettet</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <app-date-user [date]="opfoelgning.createdOn" [user]="opfoelgning.createdBy"></app-date-user>
      </td>
    </ng-container>
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Prioritet</th>
      <td mat-cell *matCellDef="let opfoelgning">
        @if (opfoelgning.priority === 1) {
          <div class="coin coin--red" matTooltip="Høj prioritet"></div>
        }
        @if (opfoelgning.priority === 2) {
          <div class="coin coin--orange" matTooltip="Middel prioritet"></div>
        }
        @if (opfoelgning.priority === 3) {
          <div class="coin coin--grey" matTooltip="Lav prioritet"></div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="deadline">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deadline</th>
      <td mat-cell *matCellDef="let opfoelgning">
        @if (opfoelgning.deadline) {
          <div [class]="deadline(opfoelgning)" matTooltip="Deadline d. {{ opfoelgning.deadline | date : 'shortDate' }}">
            <span>d. {{ opfoelgning.deadline | date : 'shortDate' }}</span>
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Bruger</th>
      <td mat-cell *matCellDef="let opfoelgning">
        {{ opfoelgning.user }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="onRowClick(row)"
      (dblclick)="onRowDblClick(row.serviceaftale)"
      [class.active]="globalActiveRowID == row.serviceaftale.id"
      [appScrollToRow]="prevRow"
      [rowId]="row.serviceaftale.okKundeAftaleNr"
      (rowActive)="highLight($event)"
    ></tr>
  </table>
  @if (page < pageCount) {
    <div class="align-center margin-top-x2">
      <button type="button" mat-raised-button color="accent" class="btn-trans mat-elevation-z0" (click)="more()" [disabled]="this.isLoading">
        Vis flere opfølgninger
      </button>
    </div>
  }
</div>
@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="closeQuickView()" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="selectedaftale"></app-quickview>
    <div class="quick-view__bottom">
      <app-opfoelgning-action
        [opfoelgningList]="selectedaftale.opfoelgningList"
        (opfoelgningChange)="onOpfoelgningChanged($event)"
        [entityNo]="selectedaftale.serviceAftaleNo"
      ></app-opfoelgning-action>
      <button mat-raised-button color="primary" (click)="onRowDblClick(selectedaftale)">Åben aftalen</button>
    </div>
  </div>
}
